import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@workspace/ui/components/Button';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { userStore } from '~/stores';

const iconButtonClasses =
  'size-12! max-h-none! p-0! border-transparent bg-navigation-surface text-navigation-icon-primary hover:bg-navigation-surface-2';

// Apple Guideline 5.1.1(v): favorites is bookmarking — not account-based. Hide
// the entry-point entirely for guests instead of presenting an auth wall.
export const FavoriteButton: React.FC = observer(() => {
  const navigate = useNavigate();

  if (company.hideFavoritesForGuests && !userStore.isAuthorized) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      startIcon={<Icon type="favs-3.1" width={22} height={20} />}
      className={iconButtonClasses}
      onClick={() => navigate('/favs')}
      data-button="header-favs"
    />
  );
});
